import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
} from '@mui/material';
import Modal from '@mui/material/Modal';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { ClearIcon } from '@mui/x-date-pickers';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ETheme } from '../../../../shared/enums/user/ETheme';
import { handleError } from '../../../../shared/functions/handleError';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../../shared/mui/palettes';
import { RootState } from '../../../../store/store';
import { AdminEmployeeService } from '../../employees/service';
import { ICalendarPagination } from '../index';

interface IProps {
  pagination: ICalendarPagination;
  changeFilterHandler: (name: string, value: string | number | null) => void;
}
const CalendarFilters = ({ pagination, changeFilterHandler }: IProps) => {
  const [users, setUsers] = useState<IUser[]>([]);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { theme } = useSelector(
    (state: RootState) => state.auth.userData,
  ) as IUser;
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    AdminEmployeeService.getAll({ page: 1, perPage: 0 })
      .then((response) => {
        setUsers(response?.data);
      })
      .catch(handleError);
  }, []);
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: '10px' }}>
      <Button
        variant={'contained'}
        color={'secondary'}
        onClick={() => setOpen(true)}
      >
        <FilterAltOffOutlinedIcon />
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={'MuiModalBody'}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: { xs: '80%', lg: '30%' },
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              width: '100%',
              paddingBottom: '10px',
              borderBottom: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
            }}
          >
            <Typography id="modal-modal-title" variant="h6">
              {t('general.filterCalendar')}
            </Typography>
          </Box>
          <FormControl fullWidth sx={{ marginTop: '20px' }}>
            <InputLabel>{t('general.searchByName')}</InputLabel>
            <Select
              labelId={`user-label`}
              id={`user-select`}
              value={pagination?.userId}
              label={t('general.searchByName')}
              endAdornment={
                pagination?.userId && (
                  <InputAdornment sx={{ marginRight: '10px' }} position="end">
                    <IconButton
                      onClick={() => {
                        setOpen(false);
                        changeFilterHandler('userId', null);
                      }}
                    >
                      <ClearIcon></ClearIcon>
                    </IconButton>
                  </InputAdornment>
                )
              }
              onChange={(e) => {
                changeFilterHandler('userId', Number(e.target.value));
              }}
            >
              {users?.map((user) => {
                return (
                  <MenuItem key={user?.id} value={user?.id}>
                    {user?.displayName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <div>
            <Button
              variant={'contained'}
              color={'secondary'}
              onClick={handleClose}
              sx={{ marginRight: '10px' }}
            >
              {t('button.cancel')}
            </Button>
          </div>
        </Box>
      </Modal>
    </Box>
  );
};

export default CalendarFilters;
